import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Index from "../views/Index.vue";
import Home from "@/views/Home";
import Element from "element-ui";
import Users from "@/views/sys/Users";
import Apks from "@/views/sys/Apks";
import Download from "@/views/sys/Download";
import ApksInfo from "@/views/sys/ApksInfo";
import AppVersion from "@/views/sys/AppVersion";
import AppVersioninfo from "@/views/sys/AppVersioninfo";
import DdImage from "@/views/sys/DdImage";
import DdImageInfo from "@/views/sys/DdImageInfo";
import WifiAppVersion from "@/views/sys/WifiAppVersion";
import WifiAppVersioninfo from "@/views/sys/WifiAppVersioninfo";
import Ad from "@/views/sys/Ad";
import ActiveCode from "@/views/sys/ActiveCode";
import activeCode from "@/views/sys/ActiveCode";
import activeCodeGenerate from "@/views/sys/ActiveCodeGenerate";
import Orders from "@/views/sys/Orders";
import Shop from "@/views/sys/Shop";
import Shopinfo from "@/views/sys/Shopinfo";
import AppErrlog from "@/views/sys/AppErrlog";
import Zx from "@/views/Zx";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: Login,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/zx",
    name: "zx",
    component: Zx
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    children: [
      {
        path: "/sys/index",
        name: "index",
        component: Index,
      },
      {
        path: "/sys/ad",
        name: "ad",
        component: Ad,
      },
      {
        path: "/sys/users",
        name: "user",
        component: Users,
      },
      {
        path: "/sys/apksinfo",
        name: "apksinfo",
        component: ApksInfo,
      },
      {
        path: "/sys/ddImage",
        name: "ddImage",
        component: DdImage,
      },
      {
        path: "/sys/ddImageInfo",
        name: "ddImageInfo",
        component: DdImageInfo,
      },
      {
        path: "/sys/appversion",
        name: "appversion",
        component: AppVersion,
      },
      {
        path: "/sys/appversioninfo",
        name: "appversioninfo",
        component: AppVersioninfo,
      },
      {
        path: "/sys/wifiappversion",
        name: "appversion",
        component: WifiAppVersion,
      },
      {
        path: "/sys/wifiappversioninfo",
        name: "appversioninfo",
        component: WifiAppVersioninfo,
      },
      {
        path: "/sys/download",
        name: "download",
        component: Download,
      },
      {
        path: "/sys/ActiveCodeInfo",
        name: "ActiveCodeInfo",
        component: activeCode,
      },
      {
        path: "/sys/Generate",
        name: "Generate",
        component: activeCodeGenerate,
      },
      {
        path: "/sys/Orders",
        name: "Orders",
        component: Orders,
      },
      {
        path: "/sys/Shop",
        name: "Shop",
        component: Shop,
      },
      {
        path: "/sys/Shopinfo",
        name: "Shopinfo",
        component: Shopinfo,
      },
      {
        path: "/sys/appErrlog",
        name: "appErrlog",
        component: AppErrlog,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem("token");
  if (to.path == "/login" || to.path == "/" || to.path == '/zx') {
    console.log("login!!!!!!!!!!!");
    next();
  } else {
    if (!token) {
      console.log("还没有token！！！");
      Element.Message.error("请先重新登陆", { duration: 1000 });
      next({ path: "/login" });
    } else {
      next();
    }
  }
});

// let hasRoute = store.state.menus.hasRoute
// let menus = store.state.menus.menuList
//let token = localStorage.getItem("token")
// if (to.path == '/login') {
//   console.log("login!!!!!!!!!!!")
//   next()
// } else if (!token) {
//   console.log("还没有token！！！")
//   next({path: "/login"})
// }
//   }else if (to.path == '/' || to.path == '') {
//     next({path: "/index"})
//   }else if (!hasRoute) {
//     let newRoutes = router.options.routes;
//     axios.get("/sys/menu/nav", {headers:{
//         Authorization: localStorage.getItem("token")
//       }}).then(res => {
//       console.log(res.data.data)
//       store.commit("setMenuList", res.data.data.nav)
//       store.commit("setPermList", res.data.data.authoritys)
//       res.data.data.nav.forEach(menu => {
//         if (menu.children) {
//           menu.children.forEach(e => {
//             let route = menuToRoute(e)
//             if(route) {
//               newRoutes[0].children.push(route)
//             }
//           })
//         }
//       })
//       console.log("oldRoutes---------------")
//       console.log(newRoutes)
//       router.addRoutes(newRoutes)
//       store.commit("changeRouteStatus", true)
//       next({path: to.path})
//     })
//   } else {
//     console.log("已经有路由了------------")
//     next()
//   }
// })
// const menuToRoute = (menu) => {
//   console.log("正在添加menu--》")
//   console.log(menu)
//   if (!menu.component) {
//     return null
//   }
//   // 复制属性
//   let route = {
//     name: menu.name,
//     path: menu.path,
//     meta: {
//       icon: menu.icon,
//       title: menu.title
//     }
//   }
//   route.component = () => import('@/views/' + menu.component +'.vue')
//   return route
//}
export default router;
